module.exports = __webpack_public_path__ + "static/media/street-fall.d380190f.jpg";